import * as api from "../constants/api";
import axios from "../services/axios";
import { setTotal as setTotalAction } from "./advancedListActions";
import { addFlashMessage } from "./FlashMessagesAction";

import { getErrorMessageFromAxiosError } from "../utils/axiosUtils";
import { toIsoString } from "../utils/date";

export const GET_PIGGDEKKONTROLLER_SUCCESS = "GET_PIGGDEKKONTROLLER_SUCCESS";

export function getPiggdekkontroller(params, page, count) {
  return (dispatch) => {
    return axios
      .get(api.GET_PIGGDEKKONTROLLER_URL, {
        params: {
          ...params,
          fraDato: toIsoString(params.fraDato),
          tilDato: toIsoString(params.tilDato),
          page: page,
          pageSize: count,
        },
      })
      .then((response) => {
        const total = JSON.parse(response.headers["x-pagination"]).Total;
        dispatch(setTotalAction("piggdekkontroller", total));
        dispatch({
          type: GET_PIGGDEKKONTROLLER_SUCCESS,
          payload: response.data.result,
        });
        return Promise.resolve(true);
      })
      .catch((error) => {
        const errorMessage = getErrorMessageFromAxiosError(error);
        dispatch(addFlashMessage({ type: "error", text: errorMessage }));
        return Promise.reject(false);
      });
  };
}
